import { Button, Row } from 'antd'
import VendorForm from '../../../../../../components/Corporate/Analytics/Reports/ReportsComponents/Vendor/VendorForm'
import VendorList from '../../../../../../components/Corporate/Analytics/Reports/ReportsComponents/Vendor/VendorList'
import MoneyCell from '../../../../../../elements/Table/Cells/MoneyCell'
import CustomTable from '../../../../../../elements/Table/CustomTable'
import React from 'react'

function VendorDisplay(props) {
  const { formRef, submitting, submit, data, onClickNum } = props
  const columns = [
    { Header: 'Code', accessor: 'code', width: 100 },
    {
      Header: 'Name',
      accessor: 'name',
      style: { paddingLeft: 20, alignment: 'left' },
    },
    {
      Header: 'Vendor ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Partner ID',
      accessor: 'partner._id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'RFQ',
      accessor: 'rfq',
      width: 100,
      Cell: ({ value }) => {
        return <a onClick={() => onClickNum(null, 'rfq', value.data)}>{value.count}</a>
      },
    },
    {
      Header: 'Vendor Quote',
      accessor: 'vendorQuote',
      width: 100,
      Cell: ({ value }) => {
        return <a onClick={() => onClickNum(null, 'vendorQuote', value.data)}>{value.count}</a>
      },
    },
    {
      Header: 'Purchases',
      accessor: 'purchases',
      width: 100,
      Cell: ({ value }) => {
        return <a onClick={() => onClickNum(null, 'purchases', value.data)}>{value.count}</a>
      },
    },
    {
      Header: 'Total (USD)',
      accessor: 'purchases.total',
      width: 140,
      Cell: ({ value }) => MoneyCell({ value, currency: 'USD' }),
    },
  ]

  return (
    <>
      <VendorList {...props} />
      <Row>
        <VendorForm ref={formRef} {...props} />
        <Button style={{ width: '100px' }} type="primary" loading={submitting} onClick={submit}>
          Submit
        </Button>
      </Row>
      <Row style={{ marginTop: 30 }}>
        <CustomTable
          data={data}
          defaultPageSize={20}
          isFilterable={true}
          show={{ csv: { fileName: `Vendor-Report` } }}
          fetching={submitting}
          columns={columns}
          defaultSorted={[{ id: 'purchases.total', desc: true }, { id: 'name' }]}
        />
      </Row>
    </>
  )
}

export default VendorDisplay
